'use client';
import { OnbForm } from '@/components/form';
import { connectedField } from '@/redux/fields';
import { RootState } from '@/redux/store';
import { TextField, Typography } from '@mui/material';
import { customerIdentification } from '@repo/onb-api';
import { RadioGroup } from '@repo/ui';
import { formatter } from '@repo/utils';
import { useSelector } from 'react-redux';
import StepWrapper from './stepWrapper';

export default function CustomerIdentification({
  stepname: stepName,
}: {
  stepname?: customerIdentification['name'];
}): React.JSX.Element {
  const documentNumber = useSelector((state: RootState) => state.additionalData.documentNumber);
  const policyProduct = useSelector((state: RootState) => state.additionalData.policyProduct);
  return (
    <StepWrapper>
      <Typography variant="h1">
        {process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-cuotas'
          ? policyProduct === 'EFECTIVOC'
            ? 'Confirmá tus datos'
            : '¡Comprá en cuotas ahora!'
          : '¡Sacá tu préstamo ahora!'}
      </Typography>
      <Typography variant="h2">Empecemos: ingresá tus datos y encontrá la opción perfecta para vos.</Typography>
      <OnbForm<customerIdentification> stepName={stepName!}>
        <TextField
          label="Ingresá tu DNI"
          autoFocus
          placeholder="Ej: 12345678"
          slotProps={{ htmlInput: { maxLength: 10, inputMode: 'numeric', 'data-testid': 'documentNumber' } }}
          disabled={!!documentNumber}
          {...connectedField({
            stepName,
            name: 'documentNumber',
            required: true,
            defaultValue: documentNumber ? documentNumber : undefined,
            beforeRender: (value) => (documentNumber ? formatter(documentNumber, 'dni') : formatter(value, 'dni')),
            beforeChange: (value) => (documentNumber ? documentNumber : value.replaceAll(/\D/g, '').slice(0, 8)),
            errorHandler: {
              type: 'text',
              errorText: 'Ingresa un DNI válido',
              validate: (value) => (documentNumber ? true : value.length > 6),
            },
          })}
        />
        <RadioGroup
          aria-labelledby="gender-label"
          data-testid="gender"
          label="Seleccioná tu género"
          options={[
            { value: 'FEMALE', label: 'Femenino' },
            { value: 'MALE', label: 'Masculino' },
          ]}
          {...connectedField({
            stepName,
            name: 'gender',
            required: true,
            beforeChange: (value) => (value === 'MALE' ? 'MALE' : 'FEMALE'),
            errorHandler: {
              type: 'radioGroup',
              errorText: 'Este campo es requerido',
            },
          })}
        />
      </OnbForm>
    </StepWrapper>
  );
}
